<template>
  <div class="content" v-loading.fullscreen.lock="loading">
    <div class="row mb-3 mb-md-4 align-items-center">
      <div class="col-xl-12">
        <div class="dash-head-wrap d-flex justify-content-between align-items-center">
          <div class="dash-header">
            <h2 class="text-default m-0 d-flex">Employee Insights <img v-if="!isSafeDig" src="/signup-img/fire.svg" alt="">
            </h2>
            <!-- <p class="text-secondary">Explore Your Tailored Employee Profile Setup Guide.</p> -->
          </div>
          <span class="d-flex justify-content-end align-items-center">
            <base-button outline="true" type="primary" v-if="editor === 'company' || 'manager'"
              @click.prevent="resetFilters" class="font-weight-normal px-4 d-none d-sm-block">
              Clear Filters</base-button>
            <base-button type="primary" v-if="editor === 'company' || 'manager'" @click.prevent="createuser"
              class="font-weight-normal px-4 d-none d-sm-block">
              Add Employee</base-button>
          </span>
        </div>
      </div>
    </div>
    <div class="card top-cardheader">
      <div class="card-header border-bottom px-0 px-md-4 py-3 d-flex justify-content-between align-items-center">
        <h5 class="font-weight-normal text-default m-0">Employees Overview</h5>
        <base-button type="primary" v-if="editor === 'company' || 'manager'" @click.prevent="createuser"
          class="font-weight-normal p-0 bg-transparent border-0 shadow-none d-sm-none rounded-circle">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="20" fill="#FE672C" />
            <path d="M27 20.998H21V26.998H19V20.998H13V18.998H19V12.998H21V18.998H27V20.998Z" fill="#F7F7F9" />
          </svg>

        </base-button>
      </div>

      <div class="row m-0">
        <div class="col-md-4 p-0" @click="setFilter('2')">
          <div class="dash-card-box shadow-none border-right rounded-0 px-3 px-sm-4" style="cursor: pointer;">
            <div class="card-value-box">
              <div class="card-icon-img">
                <img :src="overviewActiveEmployeeIcon" />
              </div>
              <div class="card-left flex-grow-1 pl-3">
                <h5 class="font-weight-normal m-0" name="Active Employee">{{ filters.employeStatus == 'Inactive' ?
                  'Inactive Admins' : 'Active Admins' }}</h5>
                <span name="Active Employee"> {{ active_admins }}</span>
              </div>

            </div>
          </div>
          <!-- </router-link> -->
        </div>
        <div class="col-md-4 p-0" @click="setFilter('3')">
          <!-- <router-link class="nav-item" to="/company_courses"> -->
          <div class="dash-card-box shadow-none border-right rounded-0 px-3 px-sm-4" style="cursor: pointer;">
            <div class="card-value-box">
              <div class="card-icon-img">
                <img :src="overviewDashUserIcon" />
              </div>
              <div class="card-left flex-grow-1 pl-3">
                <h5 class="font-weight-normal m-0" name="Active Employee">{{ filters.employeStatus == 'Inactive' ?
                  'Inactive Managers' : 'Active Managers' }}</h5>
                <span name="Active Employee"> {{ active_managers }}</span>
              </div>

            </div>
          </div>
          <!-- </router-link> -->
        </div>
        <div class="col-md-4 p-0" @click="setFilter('4')">
          <!-- <router-link class="nav-item" to="/company_courses"> -->
          <div class="dash-card-box shadow-none rounded-0 px-3 px-sm-4" style="cursor: pointer;">
            <div class="card-value-box">
              <div class="card-icon-img">
                <img :src="overviewDashActiveUserIcon" />
              </div>
              <div class="card-left flex-grow-1 pl-3">
                <h5 class="font-weight-normal m-0" name="Active Employee">{{ filters.employeStatus == 'Inactive' ?
                  'Inactive Employees' : 'Active Employees' }}</h5>
                <span name="Active Employee"> {{ active_employees }}</span>
              </div>

            </div>
          </div>
          <!-- </router-link> -->
        </div>

      </div>
    </div>
    <div class="employee-content">
      <div>
        <card class="no-border-card employee-content-wrap" footer-classes="pt-1">
          <template slot="header">
            <div class="row align-items-center">
              <div class="col-12 col-md-4 text-left d-flex search-style mb-3 mb-md-0">
                <base-input v-debounce:2s.unlock="fetchData" name="Employee Search" v-model="searchQuery"
                  prepend-icon="fas fa-search" placeholder="Search...">
                </base-input>
              </div>

              <div class="col-lg-8 text-right">
                <ul class="ul-filter d-flex justify-content-end p-0 m-0">
                  <li class="border-right pr-3 mr-3 active-status-header">
                    <base-button type="primary" outline class="btn-sm" @click="toggleSorting">
                      {{ sorting ? 'Disable Sorting' : 'Enable Sorting' }}
                    </base-button>
                  </li>
                  <li class="border-right pr-3 mr-3">
                    <a href="#" class="text-default" @click.prevent="exportCsv">
                      Export
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_1081_1117)">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M3.165 4.38075C3.27047 4.48609 3.41344 4.54525 3.5625 4.54525C3.71156 4.54525 3.85453 4.48609 3.96 4.38075L5.4375 2.90325V8.4375C5.4375 8.58668 5.49676 8.72976 5.60225 8.83525C5.70774 8.94074 5.85082 9 6 9C6.14918 9 6.29226 8.94074 6.39775 8.83525C6.50324 8.72976 6.5625 8.58668 6.5625 8.4375V2.90325L8.04 4.38075C8.14663 4.48011 8.28767 4.5342 8.43339 4.53163C8.57912 4.52906 8.71816 4.47003 8.82122 4.36697C8.92428 4.26391 8.98331 4.12487 8.98588 3.97914C8.98845 3.83342 8.93436 3.69238 8.835 3.58575L6.3975 1.14825L6 0.75L5.6025 1.1475L3.165 3.585C3.11273 3.63724 3.07126 3.69926 3.04297 3.76753C3.01468 3.8358 3.00012 3.90898 3.00012 3.98288C3.00012 4.05677 3.01468 4.12995 3.04297 4.19822C3.07126 4.26649 3.11273 4.32851 3.165 4.38075ZM10.125 7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125V9.75C11.25 10.1478 11.092 10.5294 10.8107 10.8107C10.5294 11.092 10.1478 11.25 9.75 11.25H2.25C1.85218 11.25 1.47064 11.092 1.18934 10.8107C0.908035 10.5294 0.75 10.1478 0.75 9.75V7.3125C0.75 7.16332 0.809263 7.02024 0.914753 6.91475C1.02024 6.80926 1.16332 6.75 1.3125 6.75C1.46168 6.75 1.60476 6.80926 1.71025 6.91475C1.81574 7.02024 1.875 7.16332 1.875 7.3125V9.75C1.875 9.84946 1.91451 9.94484 1.98483 10.0152C2.05516 10.0855 2.15054 10.125 2.25 10.125H9.75C9.84946 10.125 9.94484 10.0855 10.0152 10.0152C10.0855 9.94484 10.125 9.84946 10.125 9.75V7.3125Z"
                            fill="black" />
                        </g>
                        <defs>
                          <clipPath id="clip0_1081_1117">
                            <rect width="12" height="12" fill="white" transform="matrix(-1 0 0 1 12 0)" />
                          </clipPath>
                        </defs>
                      </svg>

                    </a>

                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="toggleSlide">Filters</a>
                  </li>
                </ul>
              </div>
            </div>

          </template>
          <div class="">
            <div v-if="showContent" class="all-filters mb-3">
              <div class="row justify-content-center justify-content-sm-between flex-wrap align-items-center">
                <div class="col-md-3 mt-0 mt-md-4">
                  <el-popover placement="bottom-start" trigger="click">
                    <el-checkbox-group v-model="filterValue" @change="columnFilter">
                      <el-checkbox v-for="(item, index) in filtersOptions" :label="item.value" v-bind:key="index">{{
                        item.text }}</el-checkbox>
                    </el-checkbox-group>
                    <span slot="reference" class="arrangeDownArrow">
                      <p style="font-weight: 400;">Filter User Type <i class="el-icon-arrow-down"></i></p>
                    </span>
                  </el-popover>
                </div>
                <div class="col-md-3 mb-3 mb-md-0 ignore-translation">
                  <label>Location:</label>
                  <el-select name="Employee Location Filter" filterable class="select-primary w-100 select-style"
                    v-model="filters.location_id" v-on:change="fetchData()" placeholder="Filter by Location">
                    <el-option class="select-default" v-for="item in locations" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="col-md-2 mb-3 mb-md-0">
                  <label>Status:</label>
                  <el-select name="Employee Status" class="select-primary w-100 select-style"
                    v-model="filters.employeStatus" v-on:change="changePage(1)" placeholder="Filter by Employee status">
                    <el-option class="select-primary" v-for="item in status" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="col-md-2 mb-3 mb-md-0">
                  <label>Bulk Action:</label>
                  <el-select name="Employee Bulk Action" class="select-primary w-100 select-style"
                    v-on:change="bulkClicked()" v-model="bulkValue" placeholder="Bulk Action">
                    <el-option class="select-primary" v-for="item in bulk_array" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="col-md-2">
                  <label>Showing:</label>
                  <el-select class="select-primary pagination-select w-100 select-style" v-model="perPage"
                    v-on:change="changePage(1)" placeholder="Per page">
                    <el-option class="select-primary" v-for="item in perPageOptions" :key="item" :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div class="user-eltable table-style-fancy border overflow-hidden">
              <el-table :data="tableData" row-key="id" header-row-class-name="thead-light custom-thead-light"
                role="table" class="usersGrid" @selection-change="selectionChange">
                <el-table-column v-for="column in tableColumns" :key="column.label" v-bind="column">
                </el-table-column>
                <el-table-column min-width="100px" prop="first_name" class-name="center-align ignore-translation">
                  <template slot="header">
                    <span>
                      First Name
                      <span v-if="sorting" @click="sortByColumn(0)">
                        <span>
                          <i v-if="sortedColumn == 0 && order === 'asc'" class="fas fa-arrow-up
                    text-blue linkColor" /><i v-else class="fas fa-arrow-down
                    text-blue linkColor" />
                        </span>
                      </span>
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span class="simple-link" @click="handleEdit(props.$index, props.row)">{{ props.row.first_name
                      }}</span>
                  </template>
                </el-table-column>

                <el-table-column min-width="100px" prop="last_name" class-name="ignore-translation">
                  <template slot="header">
                    <span>
                      Last Name
                      <span v-if="sorting" @click="sortByColumn(1)">
                        <span>
                          <i v-if="sortedColumn == 1 && order === 'asc'" class="fas fa-arrow-up
                    text-blue linkColor" /><i v-else class="fas fa-arrow-down
                    text-blue linkColor" />
                        </span>
                      </span>
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span class="simple-link" @click="handleEdit(props.$index, props.row)">{{ props.row.last_name
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="170px" align="left" label="" prop="location"
                  class-name="ignore-translation">
                  <template slot="header">
                    <span>
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M2.37665 6.31239L12.0933 1.68572C13.51 1.01072 14.9883 2.48989 14.3142 3.90739L9.68749 13.6232C9.05499 14.9507 7.13832 14.8691 6.62165 13.4916L5.76665 11.2091C5.68311 10.9864 5.55288 10.7842 5.38471 10.616C5.21654 10.4478 5.01433 10.3176 4.79165 10.2341L2.50832 9.37822C1.13165 8.86156 1.04915 6.94489 2.37665 6.31239Z"
                          stroke="#6D6D6D" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      Location
                      <span v-if="sorting" @click="sortByColumn(2)">
                        <span>

                          <i v-if="sortedColumn == 2 && order === 'asc'" class="fas fa-arrow-up
                    text-blue linkColor" /><i v-else class="fas fa-arrow-down
                    text-blue linkColor" />
                        </span>
                      </span>
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span v-if="props.row.company != ''">{{
                      props.row.company
                      }}</span>
                  </template>
                </el-table-column>

                <el-table-column min-width="120px" prop="">
                  <template slot="header">
                    <el-popover ref="fromPopOver" placement="top-start" min-width="250" trigger="hover">
                      <span>
                        P = Passed. This user is compliant.<br /><br />O = Open.
                        This user has open courses,but is also compliant.<br /><br />F
                        = Failed. This user is non-compliant because they did
                        not pass the assigned course in the time permitted.
                      </span>
                    </el-popover>
                    <span>
                      P/O/F
                      <span v-if="sorting" @click="sortByColumn(4)">
                        <span>
                          <i v-popover:fromPopOver class="el-icon-question text-blue" />&nbsp;
                          <i v-if="sortedColumn == 4 && order === 'asc'" class="fas fa-arrow-up
                    text-blue" /><i v-else class="fas fa-arrow-down
                    text-blue" />
                        </span>
                      </span>
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span v-on:click="openCourseDetails(props.row)">
                      <base-button type=" pof-value pofcolorfail" class="POF_btn" v-if="props.row.fail != '0'">{{
                        props.row.passOpenFail }}</base-button>
                      <base-button type=" pof-value pofcoloropen" class="POF_btn" v-else-if="props.row.open != '0'">{{
                        props.row.passOpenFail
                        }}</base-button>
                      <base-button type=" pof-value pofcolorpass" class="POF_btn" v-else-if="props.row.pass != '0'">{{
                        props.row.passOpenFail
                        }}</base-button>
                      <base-button type="default" class="POF_btn" v-else>{{
                        props.row.passOpenFail
                        }}</base-button>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column min-width="120px" align="left" prop="type">
                  <template slot="header">
                    <span>
                      User Type
                      <span v-if="sorting" @click="sortByColumn(3)">

                        <span>
                          <i v-if="sortedColumn == 3 && order === 'asc'" class="fas fa-arrow-up
                    text-blue linkColor" /><i v-else class="fas fa-arrow-down
                    text-blue linkColor" />
                        </span>
                      </span>
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span v-if="props.row.type == 'employee'">Employee </span>
                    <span v-if="props.row.type == 'location_manager'">Manager</span>
                    <span v-if="props.row.type == 'admin'">Admin</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="120px" label="Status" prop="status" align="left">
                  <template slot-scope="props">
                    <div class="d-flex active-status" v-on:click="changeStatus(props.$index, props.row)">
                      <base-switch class="mr-1" v-if="props.row.status" type="success"
                        v-model="props.row.status"></base-switch>
                      <base-switch class="mr-1" v-else type="danger" v-model="props.row.status"></base-switch>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column min-width="110px" class-name="td-actions table-custom-size " label="Actions">
                  <template slot-scope="props">
                    <div class="actions-container">
                      <el-tooltip content="Edit" placement="top">
                        <base-button name="Edit Employee" size="sm" type="" icon
                          @click="handleEdit(props.$index, props.row)" data-toggle="tooltip" data-original-title="Edit">
                          <img class="ico-edit" src="/img/icons/common/edit.svg" alt="" />
                        </base-button>
                      </el-tooltip>

                      <el-tooltip content="Send Email" placement="top" v-if="props.row.email">
                        <base-button name="Send Email" type="" size="sm" icon
                          @click="handleEnvelope(props.$index, props.row)" data-toggle="tooltip"
                          data-original-title="Send Email">
                          <img class="ico-email" src="/img/icons/common/email.svg" alt="" />
                        </base-button>
                      </el-tooltip>
                      <base-button v-else="props.row.email" class="off-btn" type="" size="sm" icon>
                        <img class="ico-email" src="/img/icons/common/email.svg" alt="" />
                      </base-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div slot="footer" class="d-flex justify-content-end ">
            <nav v-if="pagination && tableData.length > 0">
              <div class="row">
                <div class="col-md-12">
                  <ul class="pagination custompagination  justify-content-end align-items-center">
                    <p class="p-0 m-0 mr-2">
                      Showing {{ tableData.length }} of {{ totalData }} entries
                    </p>
                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                      <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)"><i
                          class="fa fa-caret-left "></i>
                      </a>
                    </li>
                    <li v-for="(page, index) in pagesNumber" class="page-item" :class="{ active: page == currentPage }"
                      v-bind:key="index">
                      <a href="javascript:void(0)" @click.prevent="changePage(page)" class="page-link">{{ page }}</a>
                    </li>
                    <li class="page-item" :class="{
                      disabled: currentPage === last_page
                    }">
                      <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)"><i
                          class="fa fa-caret-right "></i></a>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </card>
      </div>
    </div>
    <modal :show.sync="employeeDataModal" class="user-modal">
      <span slot="header" class="title title-up text-primary assign-coures" style=" width: 100%">

        {{ employeeCoursesData.first_name }}
        {{ employeeCoursesData.last_name }}'s Assigned Courses

        {{ employeeCoursesData.type == 'admin' ? "(Company Administrator)"
          : employeeCoursesData.type == 'employee' ? '(Employee)'
            : employeeCoursesData.type == 'location_manager' ? "(Manager)"
              : "" }}
        <span style="float:right;">
          <base-button class="ml-5" type="primary" @click.prevent="
            downloadBulkCertificate(course_employee_id, course_company_id)
            ">
            Download Certifcate
          </base-button>
          <base-button type="primary" @click.prevent="
            showAssigncoursefolders(course_employee_id, course_company_id)
            ">
            Assign Course Folder
          </base-button>

          <base-button name="Assign Course Screen" type="primary" @click.prevent="
            showAssigncourse(course_employee_id, course_company_id)
            ">
            Assign course
          </base-button>
        </span>
      </span>

      <form>
        <div class="user-eltable table-style-fancy border overflow-hidden">
          <el-table :data="employeeCoursesData.courseData" style="width: 100%" role="table" class="pofGrid formatTable"
            header-row-class-name="thead-light">
            <el-table-column min-width="100px" align="left" class="check">
              <template slot="header">
                <el-popover ref="fromPopOver" placement="top-start" width="250" trigger="hover">
                  <span style="display: flex; justify-content: center;">
                    Select the check box next to each course to download the
                    certificates.
                  </span>
                </el-popover>
                <span>
                  <i v-popover:fromPopOver class="el-icon-question
                    text-blue" />
                </span>
              </template>
              <template slot-scope="props">
                <span>
                  <div class="" v-if="props.row.employee_course_status === 1">
                    <base-checkbox class="" v-model="props.row.course_checked"
                      v-on:input="courseCheckchange(props.row)"></base-checkbox>
                  </div>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="Lesson name" min-width="200px" align="left" class-name="ignore-translation">
              <template slot="header">
                <span @click="sortBy('name')" style="cursor: pointer;">
                  Lesson Name <span style="color: orange;">{{ getSortArrow('name') }}</span>
                </span>
              </template>
              <template slot-scope="props">
                <span>{{ props.row.name }}</span>
              </template>
            </el-table-column>

            <el-table-column label="Lesson Status" min-width="150px" align="left" class-name="ignore-translation">
              <template slot="header">
                <span @click="sortBy('employee_course_status')" style="cursor: pointer;">
                  Lesson Status <span style="color: orange;">{{ getSortArrow('employee_course_status') }}</span>
                </span>
              </template>
              <template slot-scope="props">
                <span v-if="props.row.employee_course_status === 1">Pass</span>
                <span v-if="props.row.employee_course_status === 2">Open</span>
                <span v-if="props.row.employee_course_status === 0">Fail</span>
                <span v-if="props.row.employee_course_status === 3">Expired</span>
              </template>
            </el-table-column>

            <!--employee_course_due_date-->
            <el-table-column label="Date Completed" min-width="140px" align="left">
              <template slot="header">
                <span @click="sortBy('employee_course_date_completed')" style="cursor: pointer;">
                  Date Completed <span style="color: orange;">{{ getSortArrow('employee_course_date_completed')
                    }}</span>
                </span>
              </template>
              <template slot-scope="props">
                <span v-if="props.row.employee_course_date_completed === null">Not Available</span>
                <span v-else>{{ formattedDate(props.row.employee_course_date_completed) }}</span>
              </template>
            </el-table-column>

            <el-table-column label="Date Assigned" min-width="140px" align="left">
              <template slot="header">
                <span @click="sortBy('employee_course_date_assigned')" style="cursor: pointer;">
                  Date Assigned <span style="color: orange;">{{ getSortArrow('employee_course_date_assigned') }}</span>
                </span>
              </template>
              <template slot-scope="props">
                <span v-if="isLiteralNotAvailableCourseDate(props.row.employee_course_date_assigned)">Not available</span>
                <span v-else>{{ formattedDate(props.row.employee_course_date_assigned) }}</span>
              </template>
            </el-table-column>

            <el-table-column label="Due Date" min-width="120px" align="left">
              <template slot="header">
                <span @click="sortBy('employee_course_due_date')" style="cursor: pointer;">
                  Due Date <span style="color: orange;">{{ getSortArrow('employee_course_due_date') }}</span>
                </span>
              </template>
              <template slot-scope="props">
                <span v-if="isLiteralNotAvailableCourseDate(props.row.employee_course_due_date)">Not available</span>
                <span v-else>{{ formattedDate(props.row.employee_course_due_date) }}</span>
              </template>
            </el-table-column>

            <el-table-column label="Expiration Date" min-width="150px" align="left">
              <template slot="header">
                <span @click="sortBy('cerificate_expiration_date')" style="cursor: pointer;">
                  Expiration Date <span style="color: orange;">{{ getSortArrow('cerificate_expiration_date') }}</span>
                </span>
              </template>
              <template slot-scope="props">
                <span v-if="(props.row.employee_course_status === 1 && props.row.cerificate_expiration_date)">
                  {{ formattedDate(props.row.cerificate_expiration_date) }}
                </span>
                <span v-if="(props.row.employee_course_status === 1 && !props.row.cerificate_expiration_date)">
                  N/A
                </span>
              </template>
            </el-table-column>

            <el-table-column label="Action" property="" align="left" min-width="160px"
              class-name="td-actions table-custom-size ">
              <template slot-scope="props">
                <div class="actions-container">
                  <el-tooltip content="Preview" placement="top" v-if="
                    props.row.employee_course_status === 1 &&
                    props.row.is_food_certifcate === 1
                  ">
                    <a class="linkColor action-btn" @click.prevent="
                      getProctoredExamCertificate(
                        props.row.food_safe_certificate_url
                      )
                      " data-original-title="Preview" data-toggle="tooltip">
                      <span>
                        <img class="ico-eye" src="/img/icons/common/eye_icon.svg" alt="" />

                      </span>
                    </a>
                  </el-tooltip>
                  <el-tooltip content="Preview" placement="top" v-else-if="
                    !props.row.is_coursefolder &&
                    props.row.employee_course_status === 1 &&
                    props.row.is_food_certifcate === 0
                  ">
                    <a class="action-btn" :href="baseUrl +
                      '/downloadCourseCertificate/preview/' +
                      props.row.id +
                      '/' +
                      course_employee_id +
                      '/' +
                      props.row.employee_certificate_id +
                      '/' +
                      props.row.is_coursefolder
                      " data-toggle="tooltip" data-original-title="Preview" target="_blank">
                      <span> <img class="ico-eye" src="/img/icons/common/eye_icon.svg" alt="" />
                      </span></a>
                  </el-tooltip>


                  <el-tooltip content="Download" placement="top" v-if="
                    !props.row.is_coursefolder &&
                    props.row.employee_course_status === 1 &&
                    props.row.is_food_certifcate === 0
                  ">
                    <a class="action-btn" :href="baseUrl +
                      '/downloadCourseCertificate/download/' +
                      props.row.id +
                      '/' +
                      course_employee_id +
                      '/' +
                      props.row.employee_certificate_id +
                      '/' +
                      props.row.is_coursefolder
                      " data-toggle="tooltip" data-original-title="Download" download="true">
                      <span> <img class="ico-download" src="/img/icons/common/download_icon.svg" alt="" /> </span></a>
                  </el-tooltip>


                  <el-tooltip content="Delete" placement="top" v-if="props.row.employee_course_status != 1">
                    <base-button type="" size="sm" @click="unAssignedCourse($index, props.row)" data-toggle="tooltip"
                      data-original-title="Delete">
                      <img class="ico-del" src="/img/icons/common/delete-icon.svg" alt="" />
                    </base-button>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="text-center my-4"></div>

        <div class="clearfix"></div>
      </form>
    </modal>
    <modal :show.sync="employeeEmailModal">
      <h3 slot="header" class="title title-up text-primary">
        Send Reminder Email to ({{ employeeEmailData.first_name }}
        {{ employeeEmailData.last_name }})
      </h3>
      <form>
        <div class="row">
          <div class="col-md-6 mb-2">
            <base-button name="Coures Due Reminder Email" outline="true" type="primary" class="btn btn-wd w-100"
              @click.prevent="sendReminderEmail">
              Courses Due Reminder Email
            </base-button>
          </div>
          <div class="col-md-6 mb-2">
            <base-button name="Resend Welcome Email" outline="true" type="primary" class="btn btn-primary btn-wd w-100"
              @click.prevent="sendWelcomeEmail">
              Resend Welcome Email
            </base-button>
          </div>
          <div class="col-md-6 my-2">
            <base-button name="Reset Password Email" type="primary" outline="true" class="btn btn-wd w-100"
              @click.prevent="sendPasswordResetEmail">
              Reset Password Email
            </base-button>
          </div>
        </div>
        <div class="clearfix"></div>
      </form>
    </modal>
    <modal :show.sync="reassignLocationModel">
      <h3 slot="header" class="title title-up text-primary">Select Location</h3>
      <form>
        <div class="row">
          <div class="col-md-12 select-style">
            <el-select v-model="bulk_location_id" class="w-100" placeholder="Filter by Location">
              <el-option class="select-default" v-for="item in locations" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="text-right mt-2">
          <base-button type="primary" name="Assign Location" @click.prevent="assignBulkLocation">
            Assign Location
          </base-button>
        </div>
        <div class="clearfix"></div>
      </form>
    </modal>

    <modal :show.sync="courseAssigneeModal">
      <h3 slot="header" style="color: #444c57" class="title title-up">
        Assign Course
      </h3>
      <form>
        <div class="row">
          <div class="col-md-12 text-right">
            <base-button type="primary" name="Assign Course" @click.prevent="assignCourse">
              {{ assigning ? "Processing" : "Assign Course" }}
            </base-button>
          </div>
          <div class="col-md-12 select-style">
            <base-input label="Select any Course to Assign:">
              <el-select multiple v-model="assigned_course_id" filterable class="course_dropdown" name="course">
                <el-option v-for="(course, index) in courses" name="course" :key="index" :label="course.name"
                  :value="course.id">
                </el-option>
              </el-select>
            </base-input>
          </div>
        </div>
        <div class="clearfix"></div>
      </form>
    </modal>
    <modal :show.sync="courseFolderAssigneeModal">
      <h3 slot="header" style="color: #444c57" class="title title-up">
        Assign Course Folder
      </h3>
      <form>
        <div class="row">
          <div class="col-md-12 text-right">
            <base-button type="primary" @click.prevent="assignCourseFolder">
              {{ assigning ? "Processing" : "Assign Course Folder" }}
            </base-button>
          </div>
          <div class="col-md-12 select-style">
            <base-input label="Select Course Folder to Assign:">
              <el-select multiple filterable style="width:100%" v-model="assigned_coursefolder_id"
                class="course_dropdown" name="course">
                <el-option v-for="(course, index) in coursefolders" name="course" :key="index"
                  :label="course.folder_name" :value="course.id">
                </el-option>
              </el-select>
            </base-input>
          </div>
        </div>
        <div class="clearfix"></div>
      </form>
    </modal>
    <modal :show.sync="download_certificate">
      <div class="row">
        <div class="col-md-4"></div>
        <div class="col-md-4">
          <h6 class="title title-up">
            Download Certificates of {{ employeeCoursesData.first_name }}
            {{ employeeCoursesData.last_name }}
          </h6>
          <a download :href="download_file_link" class="btn btn-default">Download</a>
        </div>
        <div class="col-md-4"></div>
      </div>
    </modal>

    <modal :show.sync="courseUnassigneeModal">
      <h3 slot="header">Unassign Course</h3>
      <form>
        <div class="row">
          <div class=" col-md-12 text-right">
            <base-button type="primary" name="Unassign Course" @click.prevent="unassignCourse">
              {{ unassigning ? "Processing" : "Unassign Course" }}
            </base-button>
          </div>

          <div class="col-md-12">
            <base-input label="Select Course to Unassign" class="select-style">
              <el-select multiple v-model="unassigned_course_id" class="course_dropdown w-100" name="course">
                <el-option v-for="(course, index) in courses" name="course" :key="index" :label="course.name"
                  :value="course.id">
                </el-option>
              </el-select>
            </base-input>
          </div>
        </div>

        <div class="clearfix"></div>
      </form>
    </modal>
    <modal :show.sync="courseFolderUnassigneeModal">
      <h4 slot="header">Unassign Course Folder</h4>
      <form>
        <div class="row">
          <div class="col-md-12">
            <label class="form-control-label">Select Course Folder to Unassign</label>
          </div>
          <div class="col-md-12 select-style">
            <el-select multiple style="width:100%" v-model="unassigned_coursefolder_id" class="course_dropdown"
              name="course">
              <el-option v-for="(course, index) in coursefolders" name="course" :key="index" :label="course.folder_name"
                :value="course.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="text-right mt-2">
          <base-button type="primary" outline @click.prevent="courseFolderUnassigneeModal = false">
            Cancel
          </base-button>
          <base-button type="primary" @click.prevent="unassignCourseFolder">
            {{ unassigning ? "Processing" : "Unassign Course Folder" }}
          </base-button>
        </div>
        <div class="clearfix"></div>
      </form>
    </modal>
  </div>
</template>
<script>
import {
  DatePicker,
  Dropdown,
  DropdownItem,
  Collapse,
  CollapseItem,
  DropdownMenu,
  Table,
  TableColumn,
  Select,
  Option,
  Checkbox,
  CheckboxGroup,
  Button
} from "element-ui";
import serverSidePaginationMixin from "../Tables/PaginatedTables/serverSidePaginationMixin";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import moment from "moment";
import Vue from "vue";
import vueDebounce from "vue-debounce";
let timeout = null;
Vue.use(vueDebounce, {
  lock: true
});
export default {
  mixins: [serverSidePaginationMixin],
  components: {
    [Checkbox.name]: Checkbox,
    [Dropdown.name]: Dropdown,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker
  },
  data() {
    return {
      sortKey: '',
      sortOrder: 1, // 1 = ascending, -1 = descending
      baseUrl: this.$baseUrl,
      loading: false,
      showContent: false, // State to control visibility
      check_all: false,
      check_all_course: false,
      isLoading: false,
      fullPage: true,
      course_employee_id: "",
      courses: [],
      bulk_location_id: "",
      course_due_date: "",
      reassignLocationModel: false,
      company_id: "",
      hot_user: "",
      hot_token: "",
      config: "",
      company_name: "",
      employeeEmailModal: false,
      courseAssigneeModal: false,
      courseUnassigneeModal: false,
      courseFolderUnassigneeModal: false,
      courseFolderAssigneeModal: false,
      checked_employee: [],
      checked_course: [],
      bulkValue: "",
      location: {
        locationName: "",
        locationStatus: true
      },
      employeeCoursesData: {
        first_name: "",
        last_name: "",
        location: "",
        type: "",
        courseData: []
      },
      employeeEmailData: {
        first_name: "",
        last_name: "",
        location: "",
        id: ""
      },
      download_certificate: false,
      download_file_link: "",
      bulk_array: [
        {
          label: "Make User Active",
          value: "make_employee_active"
        },
        {
          label: "Make User Inactive",
          value: "make_employee_in_active"
        },
        {
          label: "Assign Course Folder",
          value: "assign_course_folder"
        },
        {
          label: "Unassign Course Folder",
          value: "unassign_course_folder"
        },
        {
          label: "Assign Course",
          value: "assign_course"
        },
        {
          label: "Unassign Course",
          value: "unassign_course"
        },
        {
          label: "Reassign Location",
          value: "reassign_location"
        }
      ],
      status: [
        {
          label: "Active",
          value: "Active"
        },
        {
          label: "Inactive",
          value: "Inactive"
        },
        {
          label: "Show All",
          value: ""
        }
      ],
      filtersOptions: [
        { text: "All Admins", value: "2" },
        { text: "All Managers", value: "3" },
        { text: "All Employees", value: "4" }
      ],
      tableColumns: [
        {
          type: "selection"
        }
      ],
      selectedRows: [],
      filters: {
        employeStatus: "Active",
        location_id: ""
      },

      checked_all: false,
      checked_all_courses: false,
      searchQuery: "",
      tbl_data: [],
      tableData: [],
      locations: [
        {
          label: "All Locations",
          value: ""
        }
      ],
      employeeDataModal: false,
      checked_courses: [],
      coursefolders: [],
      assigning: false,
      unassigning: false,
      assigned_course_id: "",
      unassigned_course_id: "",
      assigned_coursefolder_id: "",
      unassigned_coursefolder_id: "",
      editor: "",
      awaitingSearch: false,
      manager_id: "",
      admin_id: "",
      course_company_id: "",
      filterValue: [],
      show_loader: false,
      total_emp_count: "",
      active_emp_count: "",
      inActive_emp_count: "",
      month_emp_count: "",
      active_admins: "",
      active_managers: "",
      active_employees: "",
      sorting: true,
    };
  },
  computed: {
    isSafeDig() {
      return process.env.VUE_APP_COMPANY_NAME_FRONTEND === "safedig";
    },
    overviewActiveEmployeeIcon() {
      return this.isSafeDig
        ? require("@/assets/safe-dig/svg-icons/active_employee.svg")
        : "img/svg-icons/active_employee.svg";
    },
    overviewDashUserIcon() {
      return this.isSafeDig
        ? require("@/assets/safe-dig/svg-icons/dash-user.svg")
        : "img/svg-icons/dash-user.svg";
    },
    overviewDashActiveUserIcon() {
      return this.isSafeDig
        ? require("@/assets/safe-dig/svg-icons/active-user.svg")
        : "img/svg-icons/dash-active-user.svg";
    },
  },
  created: function () {
    if (localStorage.getItem("hot-token")) {
      this.hot_user = localStorage.getItem("hot-user");
      this.hot_token = localStorage.getItem("hot-token");
      this.company_id = localStorage.getItem("hot-user-id");
      this.company_name = localStorage.getItem("hot-company-name");
      this.admin_id = localStorage.getItem("hot-admin-id");
    }
    if (localStorage.getItem("hot-user") === "employee") {
      this.editor = "employee";
    } else if (localStorage.getItem("hot-user") === "super-admin") {
      this.editor = "super-admin";
    } else if (localStorage.getItem("hot-user") === "sub-admin") {
      this.editor = "sub-admin";
    } else if (localStorage.getItem("hot-user") === "company-admin") {
      this.editor = "company";
    } else if (localStorage.getItem("hot-user") === "manager") {
      this.editor = "manager";
      this.manager_id = localStorage.getItem("hot-user-id");
    }
    if (this.$route.query.id) {
      this.filters.location_id = parseInt(this.$route.query.id);
    }
    this.fetchData();
    // this.fetchEmployeeCount();

  },
  // watch: {
  //   searchQuery: function() {
  //     if (this.searchQuery.length > 3 || this.searchQuery.length == 0) {
  //       clearTimeout(timeout);
  //       timeout = setTimeout(() => {
  //         this.fetchData();
  //       }, 300);
  //     }
  //   }
  // },
  methods: {
    sortBy(key) {
      if (this.sortKey === key) {
        this.sortOrder *= -1; // toggle
      } else {
        this.sortKey = key;
        this.sortOrder = 1; // default to ascending
      }

      this.employeeCoursesData.courseData.sort((a, b) => {
        const valA = this.getComparableValue(a, key);
        const valB = this.getComparableValue(b, key);

        if (valA < valB) return -1 * this.sortOrder;
        if (valA > valB) return 1 * this.sortOrder;
        return 0;
      });

    },
    getComparableValue(item, key) {
      let val = item[key];

      // If it's null, undefined, or marked N/A or Not Available, send to bottom
      if (!val || val === 'N/A' || val === 'Not Available') {
        return new Date(0); // earliest possible date — will be sorted to top or bottom based on order
      }

      // Handle string dates
      const parsedDate = Date.parse(val);
      if (!isNaN(parsedDate)) {
        return new Date(parsedDate);
      }

      // Fallback to string comparison
      return val.toString().toLowerCase();
    },

    getSortArrow(key) {
      if (this.sortKey !== key) return '';
      return this.sortOrder === 1 ? '↑' : '↓';
    },
    async toggleSorting() {

      this.loading = true; // Start loading
      this.sorting = !this.sorting; // Toggle sorting

      await this.fetchData();

      this.loading = false; // Stop loading
    },
    setFilter(value) {
      // Toggle selection
      if (this.filterValue.includes(value)) {
        this.filterValue = this.filterValue.filter(item => item !== value);
      } else {
        this.filterValue = [value]; // Set only one at a time (or allow multiple)
      }

      this.columnFilter(); // Trigger filtering
    },
    // fetchEmployeeCount() {
    //   if (this.editor == "company") {
    //     this.loading = true;
    //     this.$http.get("/employee-count").then((res) => {
    //       this.total_emp_count = res.data.total;
    //       this.active_emp_count = res.data.active_total;
    //       this.inActive_emp_count = res.data.inactive_total;
    //       this.month_emp_count = res.data.new_employees_total;
    //       this.active_admins=res.data.active_admins_total;
    //       this.active_managers=res.data.active_managers_total;
    //       this.active_employees=res.data.active_employees_total;
    //     });
    //   }
    // },
    createuser() {
      this.$router.push("/add_employee");
    },
    formattedDate(data) {
      return moment(data).format("MM-DD-YYYY");
    },
    isLiteralNotAvailableCourseDate(val) {
      return val === "Not available";
    },
    resetFilters() {
      this.bulkValue = "";
      this.filters = {
        employeStatus: "Active",
        // location_id: ""
      };
      this.searchQuery = "";
      this.filterValue = [];
      this.fetchData();
    },
    assignCourse() {
      this.assigning = true;
      if (this.assigned_course_id !== "") {
        let data = {
          course_id: this.assigned_course_id,
          company_id: this.course_company_id,
          assign_to: [
            {
              employee_ids: [],
              assign_to: "employee"
            }
          ]
        };

        if (this.selectedRows.length > 0) {
          for (let id of this.selectedRows) {
            let obj = {
              id: id
            };
            data.assign_to[0].employee_ids.push(obj);
          }
        } else {
          let obj = {
            id: this.course_employee_id
          };
          data.assign_to[0].employee_ids.push(obj);
        }

        this.$http
          .post("course/assign", data, this.config)
          .then(resp => {
            this.assigning = false;
            this.courseAssigneeModal = false;
            this.bulkValue = "";
            this.assigned_course_id = "";
            this.selectedRows = [];
            this.fetchData();

            this.employeeDataModal = false;

            if (resp.data.alreadyPassed == 0 && resp.data.alreadyInProgress == 0) {
              Swal.fire({
                title: "Success!",
                text: "Course(s) has been Assigned to Employee(s)",
                icon: "success",
                confirmButtonClass: "btn btn-success",
              });
            } else {
              Swal.fire({
                title: "Success!",
                html: '<ul style="text-align: left;"><li>Course(s) Assigned: ' + resp.data.assigned + '</li><li>Course(s) In Progress: ' + resp.data.alreadyInProgress + '</li><li>Course(s) Already Passed: ' + resp.data.alreadyPassed + '</li></ul>',
                icon: "success",
                confirmButtonClass: "btn btn-success",

              });
            }

          })
          .catch(function (error) {
            Swal.fire({
              title: "Error!",
              html: error.response.data.message,
              icon: "error",
              confirmButtonClass: "btn btn-success",

            });
          });
      } else {
        this.assigning = false;
        Swal.fire({
          title: "Error!",
          text: "All fields are required!",
          icon: "error",
          confirmButtonClass: "btn btn-success",


        });
      }
    },
    assignCourseFolder() {
      this.assigning = true;
      if (this.assigned_coursefolder_id !== "") {
        let data = {
          folder_id: this.assigned_coursefolder_id,
          company_id: this.course_company_id,
          assign_to: [
            {
              employee_ids: [],
              assign_to: "employee"
            }
          ]
        };

        if (this.selectedRows.length > 0) {
          for (let id of this.selectedRows) {
            let obj = {
              id: id
            };
            data.assign_to[0].employee_ids.push(obj);
          }
        } else {
          let obj = {
            id: this.course_employee_id
          };
          data.assign_to[0].employee_ids.push(obj);
        }

        this.$http
          .post("course/assign", data, this.config)
          .then(resp => {
            this.assigning = false;
            this.courseFolderAssigneeModal = false;
            this.bulkValue = "";
            this.assigned_coursefolder_id = "";
            this.selectedRows = [];
            this.fetchData();

            this.employeeDataModal = false;
            Swal.fire({
              title: "Success!",
              text: "Course has been Assigned to these Employees",
              icon: "success",
              confirmButtonClass: "btn btn-success",

            });
          })
          .catch(function (error) {
            Swal.fire({
              title: "Error!",
              html: error.response.data.message,
              icon: "error",
              confirmButtonClass: "btn btn-success",

            });
          });
      } else {
        this.assigning = false;
        Swal.fire({
          title: "Error!",
          text: "All fields are required!",
          icon: "error",
          confirmButtonClass: "btn btn-success",

        });
      }
    },
    unassignCourse() {
      this.unassigning = true;
      if (this.unassigned_course_id !== "") {
        let data = {
          course_id: this.unassigned_course_id,
          company_id: this.company_id,
          unassign_to: [
            {
              employee_ids: [],
              unassign_to: "employee"
            }
          ]
        };
        for (let id of this.selectedRows) {
          let obj = {
            id: id
          };
          data.unassign_to[0].employee_ids.push(obj);
        }
        this.$http.post("course/unassign", data, this.config).then(resp => {
          this.unassigning = false;
          this.courseunassigneeModal = false;
          this.bulkValue = "";
          this.unassigned_course_id = "";
          this.selectedRows = [];
          this.fetchData();
          Swal.fire({
            title: "Success!",
            text: "Course has been Unassigned to these Employees",
            icon: "success",
            confirmButtonClass: "btn btn-success",

          });
        });
      } else {
        this.assigning = false;
        Swal.fire({
          title: "Error!",
          text: "All fields are required!",
          icon: "error",
          confirmButtonClass: "btn btn-success",

        });
      }
    },
    unassignCourseFolder() {
      this.unassigning = true;
      if (this.unassigned_coursefolder_id !== "") {
        let data = {
          folder_id: this.unassigned_coursefolder_id,
          company_id: this.company_id,
          unassign_to: [
            {
              employee_ids: [],
              unassign_to: "employee"
            }
          ]
        };
        for (let id of this.selectedRows) {
          let obj = {
            id: id
          };
          data.unassign_to[0].employee_ids.push(obj);
        }
        this.$http.post("course/unassign", data, this.config).then(resp => {
          this.unassigning = false;
          this.coursefolderunassigneeModal = false;
          this.bulkValue = "";
          this.unassigned_coursefolder_id = "";
          this.courseFolderUnassigneeModal = false;
          this.selectedRows = [];
          this.fetchData();
          Swal.fire({
            title: "Success!",
            text: "Course has been Unassigned to these Employees",
            icon: "success",
            confirmButtonClass: "btn btn-success",

          });
        });
      } else {
        this.assigning = false;
        Swal.fire({
          title: "Error!",
          text: "All fields are required!",
          icon: "error",
          confirmButtonClass: "btn btn-success",

        });
      }
    },
    downloadCertificates() {
      if (this.checked_courses.length > 0) {
        window.location =
          this.$baseUrl +
          "/downloadAllCourseCertificate/single/" +
          this.checked_courses.join("_") +
          "/" +
          this.course_employee_id;
      } else {
        Swal.fire({
          title: `Error`,
          text: `Please select the certificate you want to download.`,
          icon: "error",
          confirmButtonClass: "btn btn-success",

        });
      }
    },
    columnFilter(e) {
      this.fetchData();
    },
    assignBulkLocation() {
      if (this.bulk_location_id !== "") {
        let ids = [];
        for (let id of this.selectedRows) {
          let obj = {
            id: id
          };
          ids.push(obj);
        }
        this.$http
          .post(
            "employees/reassign_location",
            {
              location_id: this.bulk_location_id,
              employee_ids: ids
            },
            this.config
          )
          .then(resp => {
            this.reassignLocationModel = false;
            this.bulkValue = "";
            this.bulk_location_id = "";
            this.selectedRows = [];
            this.fetchData();
            Swal.fire({
              title: "Success!",
              text: "New Location has been Assigned to these Employees!",
              icon: "success",
              confirmButtonClass: "btn btn-success",
              // buttonsStyling: true
            });
          });
      } else {
        Swal.fire({
          title: "Error!",
          text: "Please Select Any Location!",
          icon: "error",
          confirmButtonClass: "btn btn-success",
          // buttonsStyling: true
        });
      }
    },
    bulkClicked() {
      this.check_all = false;
      if (this.selectedRows.length > 0) {
        if (this.bulkValue === "make_employee_active") {
          this.bulkChangeStatusToActive();
        } else if (this.bulkValue === "make_employee_in_active") {
          this.bulkChangeStatusToInactive();
        } else if (this.bulkValue === "assign_course") {
          this.bulkAssignCourse();
        } else if (this.bulkValue === "unassign_course") {
          this.bulkUnassignCourse();
        } else if (this.bulkValue === "assign_course_folder") {
          this.bulkAssignCourseFolder();
        } else if (this.bulkValue === "unassign_course_folder") {
          this.bulkUnassignCourseFolder();
        }
        else if (this.bulkValue === "reassign_location") {
          this.bulkReassignLocation();
        }
      } else {
        this.bulkValue = "";
        Swal.fire({
          title: "Error!",
          text: "Please Select Employees First!",
          icon: "error",
          confirmButtonClass: "btn btn-success",
          // buttonsStyling: true
        });
      }
    },
    bulkChangeStatusToActive() {
      this.bulkValue = "";
      let self = this;
      let status = 1;
      for (let id in self.selectedRows) {
        self.$http
          .put(
            "/employees/update_status/" + self.selectedRows[id],
            {
              status: status
            },
            self.config
          )
          .then(resp => {
            if (parseInt(id) === self.selectedRows.length - 1) {
              self.selectedRows = [];
              self.fetchData();
              Swal.fire({
                title: "Success!",
                text: "Status has been Changed.",
                icon: "success",
                confirmButtonClass: "btn btn-success",
                // buttonsStyling: false
              });
            }
          });
      }
    },
    bulkChangeStatusToInactive() {
      this.bulkValue = "";
      let self = this;
      let status = 0;
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to make the selected employees inactive?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn",
        cancelButtonClass: "btn greybtn",
        confirmButtonColor: "#E0E0E0",
        cancelButtonColor: "",
        confirmButtonText: "Yes!",
        cancelButtonText: "No",
      }).then(result => {
        if (result.value) {
          for (let id in self.selectedRows) {
            self.$http
              .put(
                "/employees/update_status/" + self.selectedRows[id],
                {
                  status: status
                },
                self.config
              )
              .then(resp => {
                if (parseInt(id) === self.selectedRows.length - 1) {
                  self.selectedRows = [];
                  self.fetchData();
                  Swal.fire({
                    title: "Success!",
                    text: "Status has been Changed.",
                    icon: "success",
                    confirmButtonClass: "btn btn-success",
                  });
                }
              });
          }
        }
      });
    },
    bulkAssignCourse() {
      if (this.selectedRows.length > 0) {
        this.courseAssigneeModal = true;
      } else {
        this.bulkValue = "";
        Swal.fire({
          title: "Error!",
          text: "Please Select Employees First!",
          icon: "error",
          confirmButtonClass: "btn btn-success",
          // buttonsStyling: true
        });
      }
    },
    bulkUnassignCourse() {
      if (this.selectedRows.length > 0) {
        this.courseUnassigneeModal = true;
      } else {
        this.bulkValue = "";
        Swal.fire({
          title: "Error!",
          text: "Please Select Employees First!",
          icon: "error",
          confirmButtonClass: "btn btn-success",
          // buttonsStyling: true
        });
      }
    },
    bulkAssignCourseFolder() {
      if (this.selectedRows.length > 0) {
        this.courseFolderAssigneeModal = true;
      } else {
        this.bulkValue = "";
        Swal.fire({
          title: "Error!",
          text: "Please Select Employees First!",
          icon: "error",
          confirmButtonClass: "btn btn-success",
          // buttonsStyling: true
        });
      }
    },
    bulkUnassignCourseFolder() {
      if (this.selectedRows.length > 0) {
        this.courseFolderUnassigneeModal = true;
      } else {
        this.bulkValue = "";
        Swal.fire({
          title: "Error!",
          text: "Please Select Employees First!",
          icon: "error",
          confirmButtonClass: "btn btn-success",
          // buttonsStyling: true
        });
      }
    },
    bulkReassignLocation() {
      this.reassignLocationModel = true;
    },
    sendReminderEmail() {
      let self = this;
      // let done = false;
      Swal.fire({
        title: "Are you sure?",
        icon: "warning",
        text:
          "You want to send Reminder Email to " +
          self.employeeEmailData.first_name +
          " " +
          self.employeeEmailData.last_name +
          "?",
        showCancelButton: true,
        confirmButtonClass: "btn",
        cancelButtonClass: "btn greybtn",
        confirmButtonColor: "#E0E0E0",
        cancelButtonColor: "",
        confirmButtonText: "Yes!",
        cancelButtonText: "No",
        // buttonsStyling: false
      })
        .then(result => {
          if (result.value) {
            let ids = [];
            let obj = {
              id: self.employeeEmailData.id
            };
            ids.push(obj);
            self.$http
              .post("employees/course_reminder_email", {
                company_id: self.company_id,
                ids: ids
              })
              .then(resp => {
                self.employeeEmailModal = false;
                if (resp.data.Status == 200) {
                  Swal.fire({
                    title: "Success!",
                    text: resp.data.Email[0],
                    icon: "success",
                    confirmButtonClass: "btn btn-success",
                    // buttonsStyling: false
                  });
                } else {
                  Swal.fire({
                    title: "Error!",
                    text: resp.data.Email[0],
                    icon: "error",
                    confirmButtonClass: "btn btn-success",
                    // buttonsStyling: false
                  });
                }
              });
          }
        })
        .catch(function () { });
    },
    showAssigncourse(row, course_company_id) {
      this.course_employee_id = row;
      this.course_company_id = course_company_id;
      this.courseAssigneeModal = true;
    },
    showAssigncoursefolders(row, course_company_id) {
      this.course_employee_id = row;
      this.course_company_id = course_company_id;
      this.courseFolderAssigneeModal = true;
    },
    downloadBulkCertificate(row) {
      let user_id = row;
      window.location.href = this.baseUrl + '/downloadCourseFoldersCertificate/' + user_id
    },
    sendWelcomeEmail() {
      let self = this;
      Swal.fire({
        title: "Are you sure?",
        icon: "warning",
        text:
          "You want to send Welcome Email to " +
          self.employeeEmailData.first_name +
          " " +
          self.employeeEmailData.last_name +
          "?",
        showCancelButton: true,
        confirmButtonClass: "btn",
        cancelButtonClass: "btn greybtn",
        confirmButtonColor: "#E0E0E0",
        cancelButtonColor: "",
        confirmButtonText: "Yes!",
        cancelButtonText: "No",
        // buttonsStyling: false
      })
        .then(result => {
          if (result.value) {
            let ids = [];
            let obj = {
              id: self.employeeEmailData.id
            };
            ids.push(obj);
            self.$http
              .post("employees/welcome_email", {
                company_id: self.company_id,
                ids: ids
              })
              .then(resp => {
                self.employeeEmailModal = false;
                Swal.fire({
                  title: "Success!",
                  text: "Email has been sent!",
                  icon: "success",
                  confirmButtonClass: "btn btn-success",
                  // buttonsStyling: false
                });
              });
          }
        })
        .catch(function () { });
    },
    sendPasswordResetEmail() {
      let self = this;
      Swal.fire({
        title: "Are you sure?",
        icon: "warning",
        text: "You want to reset password ?",
        showCancelButton: true,
        confirmButtonClass: "btn",
        cancelButtonClass: "btn greybtn",
        confirmButtonColor: "#E0E0E0",
        cancelButtonColor: "",
        confirmButtonText: "Yes!",
        cancelButtonText: "No",
        // buttonsStyling: false
      })
        .then(result => {
          if (result.value) {
            this.$http
              .post("employees/password_reset", {
                user_id: this.employeeEmailData.id
              })
              .then(resp => {
                this.employeeEmailModal = false;
                Swal.fire({
                  title: "Success!",
                  text:
                    "New password has been sent to " +
                    self.employeeEmailData.first_name +
                    "'s Email!",
                  icon: "success",
                  confirmButtonClass: "btn btn-success"
                }
                );
              });
          }
        })
        .catch(function () { });
    },
    handleEnvelope(index, row) {
      this.employeeEmailData.first_name = row.first_name;
      this.employeeEmailData.last_name = row.last_name;
      this.employeeEmailData.location = row.location;
      this.employeeEmailData.userName = row.location;
      this.employeeEmailData.id = row.id;
      this.employeeEmailModal = true;
    },
    handleEdit(index, row) {
      this.$router.push("/add_employee?id=" + row.id);
    },

    changeStatus(index, row) {
      let prev_val = row.status;
      let status = "";
      if (prev_val) {
        status = 0;
      } else {
        status = 1;
      }
      let self = this;
      Swal.fire({
        title: "Are you sure?",
        text: "You want to change status?",
        imageUrl: "./img/svg-icons/warning_icon.svg",
        imageWidth: 59,
        imageHeight: 59,
        showCancelButton: true,
        confirmButtonClass: "btn",
        cancelButtonClass: "btn greybtn",
        confirmButtonColor: "#E0E0E0",
        cancelButtonColor: "",
        confirmButtonText: "Yes!",
        cancelButtonText: "No",
        // reverseButtons: true,
        // buttonsStyling: false
      })
        .then(result => {
          if (result.value) {
            self.$http
              .put(
                "/employees/update_status/" + row.id,
                {
                  status: status
                },
                self.config
              )
              .then(resp => {
                self.fetchData();
                Swal.fire({
                  title: "Success!",
                  text: "Status has been Changed.",
                  icon: "success",
                  confirmButtonClass: "btn btn-success",
                  // buttonsStyling: false
                });
                self.tableData[index].status = !prev_val;
              });
          } else {
            self.tableData[index].status = prev_val;
          }
        })
        .catch(function () {
          self.tableData[index].status = prev_val;
        });
    },
    unAssignedCourse(index, row) {
      let self = this;
      Swal.fire({
        title: "Are you sure?",
        text: "You want to delete this course",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn",
        cancelButtonClass: "btn greybtn",
        confirmButtonColor: "#E0E0E0",
        cancelButtonColor: "",
        confirmButtonText: "Yes!",
        cancelButtonText: "No",
        // buttonsStyling: false
      }).then(result => {
        if (result.value) {
          self.$http
            .post(
              "employees/unassign_course",
              {
                course_id: row.id,
                employee_course_id: row.employee_course_id,
                employee_id: self.course_employee_id
              },
              self.config
            )
            .then(resp => {
              self.employeeDataModal = false;
              self.fetchData();
              Swal.fire({
                title: "Success!",
                text: "Course has been Unassigned to this Employee!",
                icon: "success",
                confirmButtonClass: "btn btn-success",
                // buttonsStyling: false
              });
            });
        }
      });
    },
    courseCheckchange(row) {
      console.clear();
      console.log(row);
      if (this.checked_courses.includes(row.employee_certificate_id)) {
        this.checked_courses.splice(
          this.checked_courses.indexOf(row.employee_certificate_id),
          1
        );
      } else {
        this.checked_courses.push(row.employee_certificate_id);
      }
    },

    openCourseDetails(row) {
      this.course_employee_id = row.id;
      this.employeeCoursesData.first_name = row.first_name;
      this.employeeCoursesData.last_name = row.last_name;
      this.employeeCoursesData.location = row.location;
      this.employeeCoursesData.type = row.type;
      this.employeeCoursesData.courseData = row.courses;
      this.course_company_id = row.company_id;
      this.employeeDataModal = true;
    },
    async fetchData() {
      if (this.editor == "company") {
        this.loading = true;
        this.$http
          .post("employees/list", {
            role: "admin",
            filter_value: this.filterValue,
            search: this.searchQuery,
            company_id: this.filters.location_id,
            employee_status: this.filters.employeStatus,
            manager_id: this.admin_id,
            page: this.currentPage,
            column: this.sortedColumn,
            order: this.order,
            per_page: this.perPage
          })
          .then(resp => {
            this.tableData = [];
            let employee_data = resp.data.employee;
            let total_data = resp.data.total;
            this.totalData = total_data;
            this.active_admins = resp.data.active_counts.admins;
            this.active_managers = resp.data.active_counts.managers;
            this.active_employees = resp.data.active_counts.employees;
            for (let data of employee_data) {
              let obj = {
                id: data.id,
                checked: false,
                first_name: data.first_name,
                last_name: data.last_name,
                email: data.email,
                company: data.name,
                company_id: data.company_id,
                type: data.type,
                location: "",
                location_id: "",
                courses: data.courses,
                passOpenFail:
                  data.course_pass_count +
                  " | " +
                  data.course_open_count +
                  " | " +
                  (data.course_fail_count + data.course_expired_count),
                pass: data.course_pass_count,
                open: data.course_open_count,
                fail: data.course_fail_count + data.course_expired_count,
                status: true
              };

              if (data.status) {
                obj.status = true;
              } else {
                obj.status = false;
              }
              this.company_id = obj.company_id;
              this.tableData.push(obj);
            }
          })
          .finally(() => (this.loading = false));

        this.$http
          .post("location/all", {
            company_id: this.company_id
          })
          .then(resp => {
            this.locations = [];
            this.locations = [
              {
                label: "All",
                value: ""
              }
            ];
            for (let loc of resp.data) {
              let obj = {
                label: loc.name,
                value: loc.id
              };
              this.locations.push(obj);
            }
          })
          .finally(() => (this.loading = false));
        this.$http
          .get("company/course_folders/" + this.company_id)
          .then(resp => {
            this.coursefolders = resp.data[0].coursefolders;
          });
        this.$http.get("company/courses/" + this.company_id).then(resp => {
          this.courses = resp.data[0].courses;
        });
      }
      if (this.editor == "manager") {
        this.loading = true;
        this.$http
          .post("employees/list", {
            role: "manager",
            filter_value: this.filterValue,
            search: this.searchQuery,
            company_id: this.filters.location_id,
            employee_status: this.filters.employeStatus,
            manager_id: this.manager_id,
            page: this.currentPage,
            column: this.sortedColumn,
            order: this.order,
            per_page: this.perPage
          })
          .then(resp => {
            this.tableData = [];
            let employee_data = resp.data.employee;
            let total_data = resp.data.total;
            this.totalData = total_data;
            this.active_admins = resp.data.active_counts.admins;
            this.active_managers = resp.data.active_counts.managers;
            this.active_employees = resp.data.active_counts.employees;
            for (let data of employee_data) {
              let obj = {
                id: data.id,
                checked: false,
                first_name: data.first_name,
                last_name: data.last_name,
                type: data.type,
                location: "",
                location_id: "",
                email: data.email,
                company: data.name,
                company_id: data.company_id,
                courses: data.courses,
                passOpenFail:
                  data.course_pass_count +
                  " | " +
                  data.course_open_count +
                  " | " +
                  (data.course_fail_count + data.course_expired_count),
                pass: data.course_pass_count,
                open: data.course_open_count,
                fail: data.course_fail_count + data.course_expired_count,
                status: true
              };

              if (data.status) {
                obj.status = true;
              } else {
                obj.status = false;
              }
              this.tableData.push(obj);
            }
          })
          .finally(() => (this.loading = false));

        this.$http
          .post("location/all", {
            company_id: this.company_id
          })
          .then(resp => {
            this.locations = [];
            this.locations = [
              {
                label: "All",
                value: ""
              }
            ];
            for (let loc of resp.data) {
              let obj = {
                label: loc.name,
                value: loc.id
              };
              this.locations.push(obj);
            }
          })
          .finally(() => (this.loading = false));
        this.$http
          .get("company/coursefolders/" + this.company_id)
          .then(resp => {
            this.coursefolders = resp.data[0].coursefolders;
          });
        this.$http.get("company/courses/" + this.company_id).then(resp => {
          this.courses = resp.data[0].courses;
        });
      }
    },
    async exportCsv() {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to export the employee data to CSV?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn",
        cancelButtonClass: "btn greybtn",
        confirmButtonColor: "#E0E0E0",
        cancelButtonColor: "",
        confirmButtonText: "Yes!",
        cancelButtonText: "No",
      });

      if (result.value) {
        this.loading = true;
        try {
          const response = await this.$http.post("employees/list", {
            role: this.editor,
            filter_value: this.filterValue,
            search: this.searchQuery,
            company_id: this.filters.location_id,
            employee_status: this.filters.employeStatus,
            manager_id: this.editor === "manager" ? this.manager_id : this.admin_id,
            page: this.currentPage,
            column: this.sortedColumn,
            order: this.order,
            per_page: this.perPage,
            export: true
          }, {
            responseType: 'blob' // Important for handling the file download
          });

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'employees.csv');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (error) {
          console.error("Error exporting CSV:", error);
          // Handle error (e.g., show an error message to the user)
        } finally {
          this.loading = false;
        }
      }
    },
    getProctoredExamCertificate: function (certificateURL) {
      this.$http
        .post("course/proctored-exam-certificate", {
          certificateURL: certificateURL
        })
        .then(resp => {
          window.open(resp.data.certificate_url, "_blank");
        });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange(selectedRowss) {
      this.selectedRows = [];
      for (let selectedRow of selectedRowss) {
        this.selectedRows.push(selectedRow.id);
      }
    },
    toggleSlide() {
      this.showContent = !this.showContent;
    },
  }
};
</script>
<style scoped>
.no-border-card .card-footer {
  border-top: 0;
}

.custom-size .btn-sm {
  padding: 2px !important;
  font-size: 16px !important;
}

.ni-cloud-upload-96 {
  margin-top: 2px;
  font-size: 18px;
}

.dash-card-box {
  /* margin-bottom: 20px; */
}

@media only screen and (max-width: 1024px),
(min-device-width: 768px) and (max-device-width: 1024px) {
  .usersGrid>>>table.el-table__body td:nth-of-type(1):before {
    content: "Checkbox";
  }

  .usersGrid>>>table.el-table__body td:nth-of-type(2):before {
    content: "Profile";
  }

  /* .usersGrid>>>table.el-table__body td:nth-of-type(3):before {
        content: "Last Name";
    } */

  .usersGrid>>>table.el-table__body td:nth-of-type(3):before {
    content: "Location";
  }

  .usersGrid>>>table.el-table__body td:nth-of-type(4):before {
    content: "P/O/F";
  }

  .usersGrid>>>table.el-table__body td:nth-of-type(5):before {
    content: "User Type";
  }

  .usersGrid>>>table.el-table__body td:nth-of-type(6):before {
    content: "Status";
  }

  .usersGrid>>>table.el-table__body td:nth-of-type(7):before {
    content: "Actions";
  }

  .pofGrid>>>table.el-table__body td:nth-of-type(1):before {
    content: "";
  }

  .pofGrid>>>table.el-table__body td:nth-of-type(2):before {
    content: "Lesson Name";
  }

  .pofGrid>>>table.el-table__body td:nth-of-type(3):before {
    content: "Lesson Status";
  }

  .pofGrid>>>table.el-table__body td:nth-of-type(4):before {
    content: "Date Completed";
  }

  .pofGrid>>>table.el-table__body td:nth-of-type(5):before {
    content: "Date Assigned";
  }

  .pofGrid>>>table.el-table__body td:nth-of-type(6):before {
    content: "Due Date";
  }

  .pofGrid>>>table.el-table__body td:nth-of-type(7):before {
    content: "Expiration Date";
  }

  .pofGrid>>>table.el-table__body td:nth-of-type(8):before {
    content: "Actions";
  }

}

@media only screen and (max-width: 1199px) {
  .pop-btn buttton {
    width: 275px;
  }

  .pop-btn button {
    width: 100%;
    margin-top: 13px;
  }
}
</style>
